/**
 * @mixin
 */
export default {
	mounted() {
		this.mounted = true;
	},
	directives: {
		move: {
			inserted: function(el, bindings) {
				const container = bindings.value
					? document.getElementById(bindings.value)
					: undefined;

				if (container) {
					container.appendChild(el);
				}
			},
			unbind: function(el, bindings) {
				const container = bindings.value
					? document.getElementById(bindings.value)
					: undefined;

				if (container) {
					container.removeChild(el);
				}
			}
		}
	},
	props: {
		/**
		 * Sets the variant of the element.
		 * Represents the global variation of the css
		 * @type {String}
		 */
		position: {
			type: String,
			default: null,
			validator: val => {
				return (
					[
						null,
						'top',
						'topStart',
						'topEnd',
						'left',
						'leftStart',
						'leftEnd',
						'right',
						'rightStart',
						'rightEnd',
						'bottom',
						'bottomStart',
						'bottomEnd'
					].indexOf(val) >= 0
				);
			}
		},
		positionStrategy: {
			type: String,
			default: 'absolute',
			validator: val => {
				return ['absolute', 'fixed'].indexOf(val) >= 0;
			}
		},
		// id of the container element
		container: {
			type: String,
			default: null
		},
		zIndex: {
			type: [Number, String],
			default: 'initial'
		},
		trackedRefName: {
			type: [Object, String, HTMLElement],
			default: undefined
		},
		placement: {
			type: String,
			default: 'top'
		},
		offset: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			positionClasses: {
				top: 'is-top',
				topStart: 'is-top-start',
				topEnd: 'is-top-end',
				left: 'is-left',
				leftStart: 'is-left-start',
				leftEnd: 'is-left-end',
				right: 'is-right',
				rightStart: 'is-right-start',
				rightEnd: 'is-right-end',
				bottom: 'is-bottom',
				bottomStart: 'is-bottom-start',
				bottomEnd: 'is-bottom-end'
			},
			instance: null,
			containerEl: undefined,
			mounted: false
		};
	},
	computed: {
		positionClassList() {
			const classArray = [];

			let vClassArray = this.positionClasses[this.position];

			if (!Array.isArray(vClassArray)) {
				//if only a stirng was passed in, convert to an array
				vClassArray = [vClassArray];
			}

			classArray.push(...vClassArray);

			return classArray;
		},
		trackedRef() {
			let ref;

			if (this.mounted) {
				if (typeof this.trackedRefName === 'string') {
					ref = this.$parent.$refs[this.trackedRefName];
					if (Array.isArray(ref)) ref = ref[0];

				} else if (typeof this.trackedRefName === 'object') {
					ref = this.trackedRefName;
				}
			}

			return ref;
		},
		popperModifiers() {
			return [
				{
					name: 'offset',
					options: {
						offset: this.offset
					}
				}
			];
		}
	}
};
